import React, { useEffect, useState } from "react";
import { useGlobalStates } from "../../utlis/ClubsContext";
import TipTapEditor from "./TipTapEditor";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import { formatTimestamp } from "../../utlis/function";
import { UserRole } from "../../utlis/constant";

const TermsMediaTab = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const { selectedClub,userRole } = useGlobalStates();
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState(null);
  const [isTermsEditing, setIsTermsEditing] = useState(false);


  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const accordionItems = [
    {
      title: "Ad Content Policy",
      content: "Ad content policy details will be displayed here.",
    },
    {
      title: "Cancellation Policy",
      content: "Cancellation policy details will be displayed here.",
    },
    {
      title: "Refund Policy",
      content: "Refund policy details will be displayed here.",
    },
    {
      title: "Venue Restrictions",
      content: "Venue restrictions details will be displayed here.",
    },
    {
      title: "Campaign Pause Rules",
      content: "Campaign pause rules details will be displayed here.",
    },
  ];

  useEffect(() => {
    setTerms(selectedClub?.terms || "");
  }, [selectedClub]);


  const EditTerms = async() => {
    try {
      setLoading(true);
      const response = await callApi({
        method:"put",
        url:`club/terms/${selectedClub.id}`,
        data:{
          terms:terms
        }
      })
      console.log("response",response);
      if(response.status === 200){
        setIsTermsEditing(false);
      }
      
    } catch (error) {
      console.log("error while update terms and conditions", error)
    }finally{
      setLoading(false)
    }
    
  }

  const handleCancel= ()=>{
    setIsTermsEditing(false);
  }
  return (
    <>
    {loading && <CommonLoader fullScreen/>}
      <div className="bg-white rounded-xl p-6 main-shadow mb-6">
        <div className="flex items-center justify-between mt-4">
        <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-5">
          Terms & Conditions
        </h2>
         {!isTermsEditing ?   <button
            onClick={() => setIsTermsEditing(true)}
             disabled={userRole === UserRole.Viewer}
            className={`flex items-center ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer text-black hover:text-primary"} gap-1 text-base font-medium transition-colors`}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.333 2.00004C11.5081 1.82494 11.716 1.68605 11.9447 1.59129C12.1735 1.49653 12.4187 1.44775 12.6663 1.44775C12.914 1.44775 13.1592 1.49653 13.3879 1.59129C13.6167 1.68605 13.8246 1.82494 13.9997 2.00004C14.1748 2.17513 14.3137 2.383 14.4084 2.61178C14.5032 2.84055 14.552 3.08575 14.552 3.33337C14.552 3.58099 14.5032 3.82619 14.4084 4.05497C14.3137 4.28374 14.1748 4.49161 13.9997 4.66671L4.99967 13.6667L1.33301 14.6667L2.33301 11L11.333 2.00004Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>
          :   <div className="flex items-center gap-2">
            <button
              onClick={EditTerms}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-primary hover:bg-hover text-white font-medium text-sm rounded-lg transition-colors"
            >
              {loading ? (
                <div className="flex items-center gap-2 text-sm text-gray-500">
                  <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
                  Saving...
                </div>
              ) : (
                "Save"
              )}
            </button>
            <button
              onClick={handleCancel}
              className="flex-1 px-4 py-2 bg-white border border-gray-200 text-textcolor font-medium text-sm rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
          </div>
        }

        </div>

        <div className="space-y-0">
          {/* {terms.map((item, index) => (
          <div key={index} className="border-b border-[#E5E5E5]">
            <button
              onClick={() => toggleAccordion(index)}
              className="cursor-pointer w-full flex items-center justify-between py-4 text-left hover:bg-gray-50 transition-colors"
            >
              <span className="text-base font-medium text-textcolor tracking-[0] leading-[normal]">
                {item.title}
              </span>
              <svg
                className={`w-5 h-5 text-black transition-transform duration-300 ${
                  openAccordion === index ? 'rotate-180' : ''
                }`}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 7.5L10 12.5L15 7.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openAccordion === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}
            >
              <div className="pb-4 px-2">
                <p className="text-sm font-normal text-textcolor tracking-[0] leading-[24px]">
                  {item.content}
                </p>
              </div>
            </div>
          </div>
        ))} */}
        
        {
          isTermsEditing ? (
            <TipTapEditor
            value={terms}
            onChange={(html)=>setTerms(html)}
            />
          ):
            <div
            className="ProseMirror text-textcolor"
            dangerouslySetInnerHTML={{ __html: terms }}
          ></div>
        }
        </div>
      </div>
      <div className="mt-6 bg-[#E8F4FD] shadow-[0_0_3.94px_0_#ABE3FF] rounded-lg p-4">
        <p className="text-lg font-medium text-[#006598] tracking-[0] leading-[normal]">
          Last updated: {formatTimestamp(selectedClub?.termsUpdatedAt)}
        </p>
      </div>
    </>
  );
};

export default TermsMediaTab;
